import { cn } from '@/lib/utils';
import React from 'react';

export const HSeparator: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
}) => {
  return <div className={cn('border-b-[1px] border-neutral-40', className)} />;
};
HSeparator.displayName = 'HSeparator';
